import { createAction, props } from '@ngrx/store';

export const setFilterValue = createAction(
  '[Pagelevel Filter] Set Filter Value',
  props<{ filterId: string; value: any }>()
);
